<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Configure Bell</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    ngbTooltip="Close"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body" hsDraggable="modal-dialog">
  <nf-form-control label="Account Owner Type">
    <ng-select
      [(ngModel)]="accountOwnerField"
      (change)="onAccountOwnerFieldChange($event)"
      [items]="accountOwnerFieldOptions"
      [clearable]="false"
      [closeOnSelect]="false"
    ></ng-select>
  </nf-form-control>
  <nf-form-control [label]="selectUserNamesLabel">
    <ng-select
      [(ngModel)]="selectedUserNames"
      [items]="userNameChoices"
      [multiple]="true"
      [searchable]="true"
      placeholder="Select a user"
      [clearable]="true"
      clearAllText="Clear"
      [clearOnBackspace]="true"
      [closeOnSelect]="false"
    ></ng-select>
  </nf-form-control>
  <em>
    <small
      >* The bell reflects the number of accounts for the configured user(s)
      that do not have an omega timestamp on or after the current selected recon
      date.</small
    >
  </em>
</div>
<div class="modal-footer" hsDraggable="modal-dialog">
  <button nf-button="cancel" (click)="activeModal.dismiss()">Cancel</button>
  <button nf-button="primary" (click)="submit()" [disabled]="!hasInitialized">
    Save
  </button>
</div>
